export class FeatureFlagConstant {
  public static UNVERIFIED_USERS = 'unverified-users';

  public static VISITATION_TRENDS = 'facility-visitation-trends';

  public static NEW_MEMBER_CONVERSION = 'new-member-conversion';
}